import mime from 'mime'
import {
  AllSupportedFileFormats,
  AllSupportedImageFormats,
  AllSupportedDocumentFormats,
  AllSupportedAudioFormats,
  AllSupportedVideoFormats,
} from './types'

export const isFilePDF = (extension: string, type?: string) => {
  const isValid =
    extension === mime.getExtension('application/pdf') &&
    type === mime.getType('pdf')

  return isValid
}

export const isFileMSG = (extension: string, type?: string) => {
  const isValid =
    // some msg files have an octet-stream mime type instead for some reason,
    // so we need to check if either is true, instead of both
    extension === mime.getExtension('application/vnd.ms-outlook') ||
    type === mime.getType('msg')

  return isValid
}

export const isSupportedFile = (filenameExtension: string): boolean => {
  return Object.values(AllSupportedFileFormats).includes(
    filenameExtension.toLowerCase() as AllSupportedFileFormats,
  )
}

export const isDocumentFile = (filenameExtension: string): boolean => {
  return Object.values(AllSupportedDocumentFormats).includes(
    filenameExtension.toLowerCase() as AllSupportedDocumentFormats,
  )
}

export const isImageFile = (filenameExtension: string): boolean => {
  return Object.values(AllSupportedImageFormats).includes(
    filenameExtension.toLowerCase() as AllSupportedImageFormats,
  )
}

export const isAudioFile = (filenameExtension: string): boolean => {
  return Object.values(AllSupportedAudioFormats).includes(
    filenameExtension.toLowerCase() as AllSupportedAudioFormats,
  )
}

export const isVideoFile = (filenameExtension: string): boolean => {
  return Object.values(AllSupportedVideoFormats).includes(
    filenameExtension.toLowerCase() as AllSupportedVideoFormats,
  )
}
